import React, { useState } from 'react';
import StbButton from '../../../../atoms/button/StbButton';

type ButtonType = 'endProject' | 'print' | 'update' | 'upload' | null;

interface ProjectActionButtonsProps {
  isLoading: boolean;
  handleEndProject: () => Promise<void>;
  handlePrint: () => Promise<void>;
  handleUpdate: () => Promise<void>;
  handleUploadToSharepoint: () => Promise<void>;
  managementView: boolean;
  disableAllExceptPrint?: boolean;
}

const ProjectActionButtons: React.FC<ProjectActionButtonsProps> = ({
  isLoading,
  handleEndProject,
  handlePrint,
  handleUpdate,
  handleUploadToSharepoint,
  managementView,
  disableAllExceptPrint = false
}) => {
  const [processingButton, setProcessingButton] = useState<ButtonType>(null);

  const handleButtonClick = (
    actionHandler: () => Promise<void>,
    buttonType: ButtonType
  ) => async () => {
    if (isLoading || processingButton) return;

    setProcessingButton(buttonType);
    try {
      await actionHandler();
    } finally {
      setProcessingButton(null);
    }
  };

  if (!managementView) {
    return null;
  }

  const isBusy = isLoading || processingButton !== null;

  return (
    <div className="stb-project-actions">
      <StbButton
        variant="secondary"
        onClick={handleButtonClick(handleEndProject, 'endProject')}
        disabled={isBusy || disableAllExceptPrint}
        loading={processingButton === 'endProject'}
      >
        {processingButton === 'endProject' ? 'Avslutar…' : 'Avsluta projekt'}
      </StbButton>
      <div className="stb-project-actions-end">
        <StbButton
          variant="secondary"
          onClick={handleButtonClick(handlePrint, 'print')}
          disabled={isBusy}
          loading={processingButton === 'print'}
        >
          {processingButton === 'print' ? 'Skriver ut…' : 'Skriv ut'}
        </StbButton>
        <StbButton
          variant="secondary"
          onClick={handleButtonClick(handleUpdate, 'update')}
          disabled={isBusy || disableAllExceptPrint}
          loading={processingButton === 'update'}
        >
          {processingButton === 'update' ? 'Uppdaterar…' : 'Uppdatera arbetsberedning'}
        </StbButton>
        <StbButton
          variant="secondary"
          onClick={handleButtonClick(handleUploadToSharepoint, 'upload')}
          disabled={isBusy || disableAllExceptPrint}
          loading={processingButton === 'upload'}
        >
          {processingButton === 'upload' ? 'Laddar upp…' : 'Ladda upp till Sharepoint'}
        </StbButton>
      </div>
    </div>
  );
};

export default ProjectActionButtons;
